import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Job} from "../domain/job";
import {JobsService} from "../services/jobs.service";
import {DatePipe, Location} from '@angular/common';
import {SharedDataService} from "../services/shared-data.service";
import {AuthenticationGuard} from '../oauth/authentication.guard';

@Component({
    selector: 'app-job-details',
    templateUrl: './job-details.component.html',
    styleUrls: ['./job-details.component.css'],
    standalone: false
})
export class JobDetailsComponent implements OnInit {

  jobName:string;
  resource: string;
  detail: Job;
  detailsList: any;
  loading: boolean;
  data:any;

  constructor(private jobsService: JobsService, private route: Router,
              private loc_pos: Location, private sharedDataService: SharedDataService,
              private authorizationService: AuthenticationGuard, private datePipe: DatePipe) {


  }
  ngOnInit() {
    this.authorizationService.checkLogin();
    this.loading = true;
    if (this.sharedDataService.job == null)
      this.loc_pos.back();

    // In  case the page is refreshed or user goes directly to that site, it is redirected to main page.
  }



  goBack() {
    this.sharedDataService.returnHome();
    this.detail = null;
    this.detailsList =null;
    // goes back to last router location
    this.loc_pos.back();
  }





}
